var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 98,
    viewBox: "0 0 178 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17479_43593)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(-90 6.5 5.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(-90 34.5 5.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(-90 90.5 5.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(-90 118.5 5.5)",
    fill: "url(#paint0_linear_17479_43593)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(-90 6.5 33.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(-90 34.5 33.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(-90 62.5 33.5)",
    fill: "url(#paint1_linear_17479_43593)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(-90 90.5 33.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(-90 34.5 61.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(-90 62.5 61.5)",
    fill: "url(#paint2_linear_17479_43593)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(-90 90.5 61.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(-90 118.5 61.5)",
    fill: "url(#paint3_linear_17479_43593)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(-90 33.5 89.5)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17479_43593",
    x1: 118.5,
    y1: 4.76837e-7,
    x2: 118.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE999E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17479_43593",
    x1: 62.5,
    y1: 28,
    x2: 62.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE999E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17479_43593",
    x1: 62.5,
    y1: 56,
    x2: 62.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE999E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17479_43593",
    x1: 118.5,
    y1: 56,
    x2: 118.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE999E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17479_43593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 178,
    fill: "white",
    transform: "translate(0 98) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.ad0f48b448ec56ae83f9a4e465c063e7.svg";
export { ForwardRef as ReactComponent };